<template>
	<div class="search-results-page">
		<keep-alive>
			<component 
				:is="currentSearchType" 
				:latest-job="newJob"
				:type="currentSearchType"
				@open="openJobInfo" 
				@archive="toggleArchivePrompt" 
				@cancel="toggleCancelPrompt"
			/>
		</keep-alive>

		<read-only-job 
			:display="displayReadOnly"
			:job="selectedJob"
			@exit="displayReadOnly = false"
		/>

		<Prompt
			:display="cancelJobConfirm"
			:close-target="'closeCancelJob'"
			:submit-target="'submitCancelJob'"
			:title="'Cancel Job'"
			:message="'Are you sure you wish to cancel this job?'"
			:state="cancelState" 
			:res="cancelRes"
			@closeCancelJob="toggleCancelPrompt"
			@submitCancelJob="cancel"
		/>

		<Prompt
			:display="archiveJobConfirm"
			:close-target="'closeCancelJob'"
			:submit-target="'submitCancelJob'"
			:title="'Archive Job'"
			:message="'Are you sure you wish to archive this job?'"
			:state="archiveState" 
			:res="archiveRes"
			@closeCancelJob="toggleArchivePrompt"
			@submitCancelJob="archive"
		/>


	</div>
</template>

<script>

	import { UpdateJob, DeleteJob } from "@/services/API.js";

	import { AmplifyEventBus } from "aws-amplify-vue";

	import { mapState } from "vuex";

	import { Logger } from "aws-amplify";
	const logger = new Logger("search results");

	import ReadOnlyJob from '@/views/Jobs/Sections/ReadOnlyJob.vue';
	import Prompt from '@/components/general/Prompt.vue';
  import Jobs from './components/JobsTable.vue';
	import Vehicles from './components/VehiclesTable.vue';
	import Devices from './components/DevicesTable.vue';

	export default {
    name: 'SearchResults',
		components: {
			ReadOnlyJob,
			Prompt,
      Jobs,
			Vehicles,
			Devices
		},
		data() {
			return {
				tab: 0,
				mode: "new",
				modal: false,
				displayReadOnly: false,
				selectedJob: {},
				cancelJobConfirm: false,
				cancelState: false,
				cancelRes: null,
				cancelTarget: {},
				archiveJobConfirm: false,
				archiveState: false,
				archiveRes: null,
				archiveTarget: {},
				newJob: {}
			}
		},
    computed: {
      currentSearchType() {
        return this.quickSearchPayload.hasOwnProperty('category') ? this.quickSearchPayload.category : 'jobs';
      },
			...mapState([
				'quickSearchPayload'
			])
    },
		watch: {
			quickSearchPayload: {
				deep: true,
				handler() {
					logger.info('search changed')
				}
			}
		},
		methods: {
			handleLatestJob(job) {
				this.newJob = job;
			},
			open(item) {
				this.mode = Object.assign({}, item);
				this.modal = true;
			},
			openJobInfo(item) {
				this.selectedJob = item;
				this.displayReadOnly = true;
			},
			async archive() {
				logger.debug("Archive", this.archiveTarget);
			
				const params = {
					archived: true
				};
				const res = await UpdateJob(this.archiveTarget.id, params);

				if (res) {
					this.archiveState = true;
					this.archiveRes = {
						msg: `Job ${this.archiveTarget.name} has been archived`,
						code: 'green'
					};

					AmplifyEventBus.$emit("job-now", {
						action: "remove",
						job: res
					});
				}
				else {
					this.archiveState = true;
					this.archiveRes = {
						msg: `An error has occurred`,
						code: 'red'
					};
				}
			},
			toggleCancelPrompt(item) {
				this.cancelState = false;
				this.cancelRes = null;
				this.cancelTarget = item;
				this.cancelJobConfirm = !this.cancelJobConfirm;
			},
			toggleArchivePrompt(item) {
				this.archiveState = false;
				this.archiveRes = null;
				this.archiveTarget = item;
				this.archiveJobConfirm = !this.archiveJobConfirm;
			},
			async cancel() {
				logger.debug("Cancel", this.cancelTarget);
				const key = this.cancelTarget.Tasks[0].task_type;
				const map = {
					taskinstall: 'otc_job',
					device_config: 'device_config_job',
					firmwareupdate: 'firmware_job'
				};
				const params = {
					job_type: map[key]
				};
				const res = await DeleteJob(this.cancelTarget.id, params);
				
				if (res) {
					this.cancelState = true;
					this.cancelRes = {
						msg: `Job ${this.cancelTarget.name} has been cancelled`,
						code: 'green'
					};

					AmplifyEventBus.$emit("job-now", {
						action: "modify",
						job: res
					});
				}
				else {
					this.cancelState = true;
					this.cancelRes = {
						msg: `An error has occurred`,
						code: 'red'
					};
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.search-results-page {
		padding: 1em;
	}
</style>